import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/pixel-cookie.gif'


const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "40",
  height: "40",
  class: "mr-5"
}, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "40",
  height: "40",
  class: "mr-5"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.align === 'left')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _renderSlot(_ctx.$slots, "default")
        ]))
  ]))
}